module.exports = __webpack_public_path__ + "static/media/spin-around.1698d567.svg";